import { FunctionComponent } from 'react';
import './StaticContent.scss';

export const LoadError: FunctionComponent = () => {
  return (
    <div className="StaticContent">
      <div className="static-content-title">Error</div>
      <p>
        There was an error while loading your data. You might try again in a bit
        or refresh this page.
      </p>
    </div>
  );
};
